import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  AccountInfo,
  BizFrontendApiService,
  IsAccountService,
  IsBeAuthComponent,
  IsBeAuthService,
  IsEnvironmentService,
} from '@interserve/angular';
import { IsIgxAppHeaderComponent } from '@interserve/igx-angular';
import { basicSettings } from './localdata';
import { MessageComponent } from './components/message/message.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    IsBeAuthComponent,
    IsIgxAppHeaderComponent,
    MessageComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  environmentKey: 'prod' | 'dev' =
    environment.environmentKey === 'prod' ? 'prod' : 'dev';
  appCd = environment.appCd;
  title = 'interserve.ui.maintenance';
  account: AccountInfo | undefined = undefined;
  dispContent = false;
  showNoPermission = false;
  organizationCd = '';
  navItems: any = basicSettings.items.layout.menu;
  constructor(
    private isAccountService: IsAccountService,
    private isBeAuthService: IsBeAuthService,
    private bizFrontendApiService: BizFrontendApiService,
    private isEnvironmentService: IsEnvironmentService,
  ) {}
  async ngOnInit(): Promise<void> {
    this.isEnvironmentService.setAppSettings({
      environmentKey: this.environmentKey,
      appCd: this.appCd,
    });
    this.isAccountService.accountSource$.subscribe(async (account) => {
      this.bizFrontendApiService
        .initializeApp(this.appCd)
        .subscribe(async (res) => {
          if (this.environmentKey === 'dev') {
            this.dispContent = true;
            return;
          }
          this.account = account;
          if (account?.organizations.length === 0) {
            this.showNoPermission = true;
            this.logout();
            return;
          }

          this.isAccountService.selectedOrganizationId =
            account?.organizations[0].organizationId || '';
          // 許可する組織コードを指定 インターサーブから取締役会＋基盤開発に変更
          // const allowOrganizationCd = ['1', '12ab2b68f3c143479d8c035ecb39095e'];
          const allowOrganizationId = [
            '37b1accf-7d0c-4b8b-b33b-76d4627b02c2', //本番 取締役会
            'eb49980f-5009-439e-b62b-dd0cdf46e5ab', //本番 基盤
            // '7190477f-e49f-45c4-a6e5-677354d6783a' //本番 アプリ開発部
          ];

          if (
            account?.organizations.some((org) =>
              allowOrganizationId.includes(org.organizationId),
            )
          ) {
            this.dispContent = true;
          } else {
            this.showNoPermission = true;
            this.logout();
          }
        });
    });
    this.showNoPermission = true;
  }
  logout(): void {
    this.isBeAuthService.logout();
    this.account = undefined;
    location.reload();
  }
}
